import { HttpClient, HttpParams } from "@angular/common/http";
import { HttpClientService } from "../httpClient/httpclient.service";
import { AuthService } from "../user/auth.service";
import { Observable } from "rxjs";
import { ListMetadata } from "app/models/list-metadata.model";
import { BarcodeResult, PromotionReport, PromotionReportData, PromotionReportPayload } from "app/models/promo-report.model";
import { Injectable } from "@angular/core";
import { of } from "rxjs/observable/of";
import { delay } from "rxjs/operators";


//TODO
@Injectable()
export class PromotionReportService {


  private baseUrl = HttpClientService.BASE_MS_CLUSTERING;
  private extraBaseUrl = 'k7o';
  barcodeUrl = '/reporting/getEanList';
  constructor(
    private http: HttpClientService,
    private authService: AuthService,
    private httpClient: HttpClient
  ) { }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<PromotionReport>, metadata: ListMetadata }> {
    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
  
    // HttpParams è immutabile, quindi creiamo un nuovo oggetto con il parametro aggiunto
    params = params.append('report_type', 'COUPON');
  
    console.log('Params:', params.toString()); // Per verificare che il parametro sia stato aggiunto correttamente
  
    return this.http.getPaged(this.baseUrl + '/reporting/getReportList' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }
  

  downloadReport(fileName: string) {
    const requestBody = { 'filename': fileName };
    const userCompany = this.authService.user.selectedCompany.toString();
    const token = `Bearer ${this.authService.user.token}`;
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };
    return this.httpClient.post(
      this.baseUrl + '/download',
      requestBody,
      {
        headers: requestHeaders,
        responseType: 'blob'
      }
    );
  }


  downloadPromoReport(fileName: string) {
    const url = `${this.extraBaseUrl}/s3/download?path=${fileName}`;
    const token = `Bearer ${this.authService.user.token}`;
    const userCompany = this.authService.user.selectedCompany.toString();
    const language = this.authService.sessionHelper.selectedLanguage;
    const requestHeaders = {
      'Accept-Company': userCompany,
      'Content-Type': 'application/json',
      'Authorization': token,
      'Accept-Language': language
    };
  
    return this.httpClient.get(url, { headers: requestHeaders, responseType: 'blob' });
  }
  
  


  saveReport(payload: { ean: string; messageId: number; startDate: string; endDate: string }, code: string, description: string, type: string) {
    return this.http.post(
      `${this.baseUrl}/reporting/createReportExcel?code=${code}&description=${description}&reportType=${type}`,
      payload
    );
  }

  searchBarcode(query: string): Observable<BarcodeResult[]> {
    let ean_code = query;
    let id_comm_type_fk = 35;
    return this.http.get(`${this.baseUrl}${this.barcodeUrl}`, { ean_code, id_comm_type_fk });
  }


}  



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-report.service.ts